/*
 * @Description: 赛程
 * @Author: zhongshanxian01
 * @Date: 2021-05-25 10:52:30
 * @LastEditors: zhongshanxian01
 * @LastEditTime: 2021-05-25 16:47:22
 */
import TagNav from './tagNav.js';
import React from 'react';
import { calculateNavPos } from '../utils/clientInit.js';
import { catchable } from '@components/catchable';
class Schedule extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            curId: props.scheduleInfo.content[0] ? props.scheduleInfo.content[0]._id : 0,
            list: []
        };
        for (let index = 0; index < props.scheduleInfo.content.length; index++) {
            this.state.list[index] = Object.assign({}, props.scheduleInfo.content[index]);
            this.state.list[index].id = props.scheduleInfo.content[index]._id;
            if (props.scheduleInfo.content[index].is_selected == 'yes' || index == 0) {
                this.state.curId = props.scheduleInfo.content[index]._id;
            }
        }
    }
    setCurId(id) {
        this.setState({
            curId: id
        });
    }
    render() {
        const { scheduleInfo, index, isHorizontal } = this.props;
        const { curId, list } = this.state;
        return (
            <div
                className={`page_item auto-height item process${index == 0 ? ' first' : ''}${
                    isHorizontal ? ' horizontal' : ''
                }`}
                key={'module' + scheduleInfo.id}
                index={index}
                id={scheduleInfo.id}
            >
                <div className="nav">
                    <h3>{scheduleInfo.module_name}</h3>
                    <TagNav
                        gotoTab={(id) => {
                            this.setCurId(id);
                            calculateNavPos();
                        }}
                        list={list}
                    ></TagNav>
                </div>
                <div className="process_item_box">
                    {list.map((processItem, index) => {
                        const {
                            m_hot_area_left,
                            m_hot_area_top,
                            m_hot_area_width,
                            m_hot_area_height,
                            m_img_width,
                            m_img_height
                        } = processItem;

                        const hotAreaStyle = {
                            left: calcPercentage(m_hot_area_left, m_img_width),
                            width: calcPercentage(m_hot_area_width, m_img_width),
                            top: calcPercentage(m_hot_area_top, m_img_height),
                            height: calcPercentage(m_hot_area_height, m_img_height)
                        };

                        if (processItem._id == curId) {
                            return (
                                <div
                                    key={'processItem' + index}
                                    className={`process_msg item${index} is_show item_control`}
                                >
                                    <div
                                        style={{
                                            display: 'block',
                                            margin: 'auto',
                                            position: 'relative'
                                        }}
                                    >
                                        <img
                                            className="process_msg_img"
                                            src={processItem.m_img || processItem.img}
                                            onLoad={() => {
                                                calculateNavPos();
                                            }}
                                        />
                                        {/* 热区 */}
                                        {processItem.m_hot_area_link && (
                                            <a
                                                className="process_msg_hot_area"
                                                style={hotAreaStyle}
                                                target="_blank"
                                                href={processItem.m_hot_area_link}
                                            />
                                        )}
                                    </div>
                                </div>
                            );
                        } else {
                            return null;
                        }
                    })}
                </div>
            </div>
        );
    }
}

export default catchable(Schedule);

/**
 * 计算百分占比
 * @param {number} width 现宽度
 * @param {number} totalWidth 总宽度
 * @returns {string} 百分比
 */
function calcPercentage(width, totalWidth) {
    width = width || 0;
    totalWidth = totalWidth || 0;

    const percentage = (width / totalWidth) * 100 || 0;

    return `${percentage}%`;
}
